import React from "react";
import { useSite } from "@/context/SiteContext";

export function BookButton({ label = "Book Your Visit", variant = "primary", track_label = "nav", className = "", testid = "book-button" }) {
  const { openBooking } = useSite();
  const base = "inline-flex items-center justify-center px-7 py-3.5 text-xs uppercase tracking-[0.18em] font-medium transition-all duration-300 cursor-pointer";
  const styles = {
    primary: "bg-espresso text-ivory hover:bg-espressosoft rounded-full",
    secondary: "border border-espresso/30 text-espresso hover:border-espresso hover:bg-linen rounded-full",
    light: "border border-ivory/50 text-ivory hover:bg-ivory hover:text-espresso rounded-full backdrop-blur-sm",
    brass: "bg-brass text-espresso hover:bg-brassdark hover:text-ivory rounded-full",
    dark: "bg-ivory text-espresso hover:bg-linen rounded-full",
  };
  return (
    <button data-testid={testid} onClick={() => openBooking(track_label)} className={`${base} ${styles[variant]} ${className}`}>
      {label}
    </button>
  );
}
